module.exports = __webpack_public_path__ + "static/media/dekton.d8931241.svg";